import TeamMain from "@/components/Team";
import Header from "@/components/Layout/Header";
import { MetaTags } from "@/components/common/Meta";
import { teamSeo } from "@/configs/seo.config";
import { Row, Col, Container } from "react-bootstrap";

const TeamPage = () => {
  return (
    <>
      <MetaTags {...teamSeo["main"]} />
      <Container fluid>
        <Header transparent withContactNavigation />
        <Row className='justify-content-center mb-mobile-4rem '>
          <Col xs={10} md={10}>
            <TeamMain />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default TeamPage;
